import { createSelector } from 'reselect';

export const selectPaymentPlansState = (state) => state.paymentPlans;

export const selectSelectedPaymentPlanId = createSelector(
  selectPaymentPlansState,
  (paymentPlansState) => paymentPlansState.selectedPaymentPlanId,
);

export const selectPaymentPlans = createSelector(
  selectPaymentPlansState,
  (paymentPlansState) => paymentPlansState.paymentPlans,
);

export const selectEligiblePaymentPlans = createSelector(
  selectPaymentPlans,
  (state) => state.tickets.tickets,
  (state) => state.bundleSales.bundles,
  (paymentPlans, tickets, bundles) => {
    return paymentPlans.filter((plan) => {
      const eligiblePriceLevelIds = new Set(plan.applicablePriceLevelIds.map(Number));
      const eligibleBundleIds = new Set(plan.applicableBundleIds.map(Number));

      const hasEligibleTickets = tickets.every((ticket) =>
        eligiblePriceLevelIds.has(Number(ticket.parent_price_level_id || ticket.price_level_id)),
      );

      const hasEligibleBundles = bundles.every((bundle) => eligibleBundleIds.has(Number(bundle.bundle_id)));

      return hasEligibleTickets && hasEligibleBundles;
    });
  },
);

export const selectPaymentPlansDynamicData = createSelector(
  selectPaymentPlansState,
  (paymentPlansState) => paymentPlansState.paymentPlansDynamicData,
);

export const selectFullPaymentPlansData = createSelector(
  selectEligiblePaymentPlans,
  selectPaymentPlansDynamicData,
  (paymentPlans, paymentPlansDynamicData) => {
    const dynamicDataByPlanId = paymentPlansDynamicData.reduce((acc, data) => {
      acc[data.paymentPlanId] = data;
      return acc;
    }, {});

    return paymentPlans.map((plan) => ({
      ...plan,
      ...dynamicDataByPlanId[plan.paymentPlanId],
    }));
  },
);

export const selectSelectedPaymentPlan = createSelector(
  selectSelectedPaymentPlanId,
  selectPaymentPlansDynamicData,
  (selectedPaymentPlanId, paymentPlans) => {
    return paymentPlans.find((plan) => Number(plan.paymentPlanId) === Number(selectedPaymentPlanId));
  },
);
